import React from "react";
import TrackVisibility from "react-on-screen";
import CountUp from "react-countup";
import { Link } from "react-router-dom";
const AboutTwo = () => {
  return (
    <div className="space">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-xl-6">
            <div className="title-area mb-30">
              <span className="sub-title">
                <img src="/assets/img/icon/title_left.svg" alt="shape" />
                About Us
              </span>
              <h2 className="sec-title style2">
               Who we are?
              </h2>
              <p className="sec-text">
                Meridian Consulting is a global IT consulting service provider
                that focuses on delivering high value through reliable,
                integrated, responsive, and cost-effective solutions. From small
                and medium to large companies, we have offered our expertise to
                enable businesses in overcoming IT-related business challenges.
              </p>
              <p className="sec-text">
                With our cutting edge services, clients are offered dynamic,
                resilient, and scalable options to ensure rapid growth. We
                integrate emerging technologies to offer solutions for complex
                IT projects.
              </p> 
              <p className="sec-text">
  Our team of experienced professionals is committed to delivering
  innovative and customized solutions tailored to each client’s unique
  needs. By combining industry best practices with a client-centric
  approach, Meridian Consulting ensures seamless execution, enhanced
  performance, and long-term business success in an ever-evolving
  digital landscape.
</p>
            </div>
           
            <div className="btn-group">
              <Link to="/about" className="global-btn style2">
                Explore More{" "}
                <img src="/assets/img/icon/right-icon.svg" alt="Bizmaster" />
              </Link>
            </div>
          </div>
          <div className="col-xl-6">
            <div className="about-thumb2">
              <div className="about-img-1">
                <img src="/assets/img/normal/about_2-1.png" alt="img" />
              </div>
              <div className="about-img-2">
                <img src="/assets/img/normal/about_2-2.png" alt="img" />
              </div>
              {/* <div className="about-img-2">
                <img src="/assets/img/normal/about_2-2.png" alt="img" />
              </div> */}
              {/* <div className="about-counter-wrap">
                <div className="about-icon">
                  <img src="/assets/img/icon/about_icon2-1.svg" alt="img" />
                  <div>
                    <h3 className="about-counter">
                      <TrackVisibility once>
                        {({ isVisible }) =>
                          isVisible && (
                            <span className="counter-number">
                              <CountUp delay={0} start={0} end={6} />
                              k+
                            </span>
                          )
                        }
                      </TrackVisibility>
                    </h3>
                    <h4 className="about-counter-text">Clients</h4>
                  </div>
                </div>
                <p className="sec-desc">
                  Lorem Ipsum is simply dummy text of the
                </p>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutTwo;
